export const paths = {
  home: '/',
  workspaces: '/workspaces',
  devices: '/devices',
  deviceById: (deviceId: number | string | null) => `/devices/${deviceId}`,
  deviceFiles: (deviceId: number | string | null) => `/devices/${deviceId}/files`,
  deviceDeployments: (deviceId: number | string | null) => `/devices/${deviceId}/deployments`,
  deviceRolloutWindows: (deviceId: number | string | null) =>
    `/devices/${deviceId}/rollout-windows`,
  deviceActionClone: (deviceId: number | string | null) => `/devices/${deviceId}/actions/clone`,
  deviceActionFleetAssignment: (deviceId: number | string | null) =>
    `/devices/${deviceId}/actions/fleet-assignment`,
  deviceSshKeys: (deviceId: number | string | null) => `/devices/${deviceId}/ssh-keys`,
  deviceNetworkConfigs: (deviceId: number | string | null) =>
    `/devices/${deviceId}/network-configs`,
  deviceActionLog: (deviceId: number | string | null) => `/devices/${deviceId}/action-log`,
  deviceActions: '/device-actions',
  store: '/store',
  storeByServiceName: (serviceName: string) => `/store/${serviceName}`,
  workspaceById: (workspaceId: number | null) => `/workspaces/${workspaceId}`,
  fleetById: (workspaceId: number | null, fleetId: number | null) =>
    `/workspaces/${workspaceId}/fleets/${fleetId}`,
  applicationById: (workspaceId: number | null, applicationId: number | null) =>
    `/workspaces/${workspaceId}/applications/${applicationId}`,
  applicationVersionById: (
    workspaceId: number | null,
    applicationId: number | null,
    applicationVersionId: number | null
  ) => `/workspaces/${workspaceId}/applications/${applicationId}/versions/${applicationVersionId}`,
  deploymentById: (
    workspaceId: number | null,
    fleetId: number | null,
    deploymentId: number | null
  ) => `/workspaces/${workspaceId}/fleets/${fleetId}/deployments/${deploymentId}`,
  workspaceFleets: (workspaceId: number | null) => `/workspaces/${workspaceId}/fleets`,
  workspaceDevices: (workspaceId: number | null) => `/workspaces/${workspaceId}/devices`,
  workspaceApplications: (workspaceId: number | null) => `/workspaces/${workspaceId}/applications`,
  workspaceFiles: (workspaceId: number | null) => `/workspaces/${workspaceId}/files`,
  workspaceServices: (workspaceId: number | null) => `/workspaces/${workspaceId}/services`,
  workspaceAppWizard: (workspaceId: number | null) => `/workspaces/${workspaceId}/app-wizard`,
  workspaceNetworkConfigs: (workspaceId: number | null) =>
    `/workspaces/${workspaceId}/network-configs`,
  workspaceDeviceTransfers: (workspaceId: number | null) =>
    `/workspaces/${workspaceId}/device-transfers`,
  workspaceStatus: (workspaceId: number | null) => `/workspaces/${workspaceId}/status`,
  workspaceEventConnections: (workspaceId: number | null) =>
    `/workspaces/${workspaceId}/event-connections`,
  repositoryById: (workspaceId: number | null, repositoryId: number | null) =>
    `/workspaces/${workspaceId}/repositories/${repositoryId}`,
  imageTagById: (workspaceId: number | null, repositoryId: number | null, imageTag: string) =>
    `/workspaces/${workspaceId}/repositories/${repositoryId}/tags/${imageTag}`,
  userByOid: (oid: string) => `/users/${oid}`,
  notFound: '/not-found',
  kpis: '/kpis',
  emmaOsLicenses: '/emma-os-licenses',
  osDownloads: '/os-downloads',
  deviceTypes: '/device-types',
} as const;
